import { ChatMessage, CopilotService, ReferenceType } from '@careerhub/api';
import { call, getContext, put, select, takeLatest, cancel, fork, take, race } from 'redux-saga/effects';
import { Awaited } from '../../types';
import { CopilotActionType, receiveMessage } from './actions';
import { copilotStateSelector } from './reducers';
import { v4 } from 'uuid';
import { copilotErrorMessage } from '../../Constants';

function* handleSendMessage() {
  const copilotState = (yield select(copilotStateSelector)) as ReturnType<typeof copilotStateSelector>;

  const copilotService: CopilotService = yield getContext('copilotService');
  try {
    const chat = async () =>
      // send only the user messages
      // TODO update to send assistant messages as well
      await copilotService.chat({
        conversationHistory: copilotState.messages.filter((m): m is ChatMessage => 'messageId' in m),
        conversationId: copilotState.conversationId,
        sessionId: copilotState.sessionId,
        userContext: copilotState.userContext,
      });
    const response: Awaited<ReturnType<typeof chat>> = yield call(chat);
    yield put(receiveMessage(response));
  } catch (ex) {
    yield put(
      receiveMessage({
        reply: copilotErrorMessage,
        followupQuestions: undefined,
        userRequest: undefined,
        references: [],
        copilotMessageId: v4(),
        createdTimestamp: undefined,
      })
    );
  }
}

function* startCopilotSaga() {
  yield race([call(handleSendMessage), take(CopilotActionType.STOP_GENERATING), take(CopilotActionType.START_OVER)]);
}

function* handleStopGenerating() {
  yield cancel(yield fork(handleSendMessage));
  yield put(
    receiveMessage({
      reply: "As requested, I've cancelled the request to generate a response",
      followupQuestions: undefined,
      userRequest: undefined,
      references: [
        {
          type: ReferenceType.Miscellaneous,
          roleLibraryReferences: undefined,
        },
      ],
      copilotMessageId: v4(),
      createdTimestamp: undefined,
    })
  );
}

export function* copilotSagas() {
  // Take latest in case the user sends two messages in rapid succession
  yield takeLatest(CopilotActionType.SEND_MESSAGE, startCopilotSaga);
  yield takeLatest(CopilotActionType.STOP_GENERATING, handleStopGenerating);
}
